module.exports = __webpack_public_path__ + "static/media/line-graph.e15890eb.svg";